import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './WhyThisMatters.module.scss'

export default function WhyThisMatters({ bodyId }) {
  return (
    <div className={`${styles.callout} d-flex align-items-start`}>
      <span className={`${styles.icon} flex-shrink-0`} aria-hidden="true">
        <i className="fa-regular fa-circle-info" />
      </span>
      <div>
        <strong>
          <FormattedMessage id="AI_RISK_REPORT.WHY_THIS_MATTERS" />
        </strong>{' '}
        <FormattedMessage id={bodyId} />
      </div>
    </div>
  )
}

WhyThisMatters.propTypes = {
  bodyId: PropTypes.string.isRequired,
}
